import * as React from 'react';
import { MoreLessGroup, LinkMoreLessWrapper, ChevronIconStyle } from './ExpandButton.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

interface PropsType {
    isExpanded: boolean;
    toggleExpand(e: React.MouseEvent): void;
    variant: DefaultComponentVariantType | null;
}

export const ExpandButton = (props: PropsType): JSX.Element => (
    <MoreLessGroup onClick={props.toggleExpand}>
        <LinkMoreLessWrapper variant={props.variant}>
            {props.isExpanded ? (
                <I18n
                    langKey='events.selections-group.less'
                    defaultText='Less'
                />
            ) : (
                <I18n
                    langKey='events.selections-group.more'
                    defaultText='More'
                />
            )}

            <ChevronIconStyle position={props.isExpanded ? 'down' : 'right'} />
        </LinkMoreLessWrapper>
    </MoreLessGroup>
);
